export const styles = (theme) => ({
    button: {
      textTransform: 'none',
      fontWeight: 'bold',
    },
  });
  
  export default styles;
  